import Button from '@cashew/button';
import ConfirmModal from '@cashew/confirm-modal';
import React from 'react';

export default ({
  showConfirmModal,
  setShowConfirmModal,
  getExcelReport,
  records,
}: any) => (
  <ConfirmModal
    isVisible={showConfirmModal}
    onClose={() => {
      setShowConfirmModal(false);
    }}
    showCloseButton={false}
    confirmTitle="Are you sure you want to export order's data?"
    confirmDescription={
      records > 20000
        ? 'Since amount of data is huge report generation may take significant time or even fail. Are you sure you want to export all selected entries from this page?'
        : 'This might take a few minutes, depending on your filter criteria.'
    }
    confirmButtons={
      <div className="export-orders">
        <Button
          extraClass="btn-black secondary"
          onClick={() => {
            setShowConfirmModal(false);
          }}
        >
          Cancel
        </Button>
        <Button
          extraClass="order-details__confirm"
          onClick={() => {
            getExcelReport();
            setShowConfirmModal(false);
          }}
        >
          Confirm
        </Button>
      </div>
    }
    resultTitle="Export cancelled"
    resultDescription="Data were not exported"
    resultButtons={<></>}
    showResult={false}
    resultStatus="none"
  />
);
